/*
 * EU-Mitteilung zur gesetzlichen Gewaehrleistung.
 * Laedt die amtliche Grafik erst beim Oeffnen und haelt einen Fallback bereit,
 * falls <dialog> nicht unterstuetzt wird (aeltere Safari-Versionen).
 */
(function () {
  function prepare(dialog) {
    if (dialog.__euOpen) return;

    dialog.__euOpen = function () {
      var img = dialog.querySelector('[data-eu-lg-src]');
      if (img && !img.getAttribute('src')) {
        img.setAttribute('src', img.getAttribute('data-eu-lg-src'));
      }
      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
      } else {
        // Fallback: Grafik in neuem Tab oeffnen, damit die Mitteilung
        // in jedem Fall vollstaendig erreichbar bleibt.
        window.open(img.getAttribute('data-eu-lg-src'), '_blank', 'noopener');
      }
    };

    // Klick auf den Hintergrund schliesst den Dialog.
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) dialog.close();
    });
  }

  function init() {
    document.querySelectorAll('dialog.eu-lg__dialog').forEach(prepare);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Sections im Theme-Editor neu laden
  document.addEventListener('shopify:section:load', init);
})();
